import React from 'react';
import { NavLink } from 'react-router-dom';

import { useTranslation } from 'react-i18next';

const Footer: React.FC = () => {
  const { t } = useTranslation('footer');
  return (
    <div className=' flex justify-between  h-14 items-center text-xs sm:text-sm  md:mx-16 '>
      <div>
        <p>Yuso BV - BE0848.269.771</p>
      </div>
      <div className='flex lg:gap-4 gap-[3px]'>
        <NavLink className='hover:text-primary-800 dark:hover:text-primary-100' to='https://support.yuso.be/en/'>
          {t('support')}
        </NavLink>
        <span>&#183;</span>
        <NavLink className='hover:text-primary-800 dark:hover:text-primary-100' to='https://yuso.be/contact/'>
          {t('contact')}
        </NavLink>
        <span>&#183;</span>
        <NavLink className='hover:text-primary-800 dark:hover:text-primary-100' to='https://yuso.be/contact/'>
          {t('terms')}
        </NavLink>
      </div>
    </div>
  );
};

export default Footer;
